export enum ShortcutPages {
  global,
  inventory,
  layout,
  layoutPicker,
  cameras,
  gamePad,
}
